'use client';

import {
	UISerializableOrder,
	getOrderLabelFromOrderDetails,
} from '@velocity-exchange/common';
import useModal from 'src/components/Modals/hooks/useModal';
import { BigNum } from '@velocity-exchange/sdk';
import { EditOrderModalContent } from 'src/components/Modals/EditOrderModal/EditOrderModalContent';
import ResponsiveModal from 'src/components/Modals/ResponsiveModal/ResponsiveModal';

export interface EditOrderModalProps {
	order: UISerializableOrder;
	newPrice?: BigNum;
}

const EditOrderModal = ({ order, newPrice }: EditOrderModalProps) => {
	const { hide } = useModal();
	const orderTypeLabel = getOrderLabelFromOrderDetails(order);

	return (
		<ResponsiveModal.Container onClose={hide} dataTestId="edit-order-modal">
			<ResponsiveModal.Title closeButtonTestId="edit-order-modal-close">
				Edit {orderTypeLabel} Order
			</ResponsiveModal.Title>
			<EditOrderModalContent order={order} newPrice={newPrice} onClose={hide} />
		</ResponsiveModal.Container>
	);
};

export default EditOrderModal;
